module.exports = __webpack_public_path__ + "static/media/lp2.ea24df6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lp2.jpg
// module id = 670
// module chunks = 29